<template>
  <div class="vipPrivilege">
    <!-- 标题栏 -->
    <van-nav-bar left-arrow title="VIP特权续费" @click-left="onClickLeft" />
    <!-- content -->
    <div class="page">
      <div class="kqb-card-list">
        <div class="kqb-card-list-item tl">
          <div class="kqb-card-list-label ellipsis">宝妈知识VIP特权年度会员宝妈知识VIP特权年度会员宝妈知识VIP特权年度会员宝妈知识VIP特权年度会员</div>
          <div class="kqb-card-list-inner fc-FF4E4F">￥365.0</div>
        </div>
      </div>
      <div class="kqb-list">
        <div class="kqb-list-item navigator-arrow">
          <div class="kqb-list-label">
            使用优惠券
          </div>
          <div class="kqb-list-right" :data-uri="'/coupon'" @click="pageJump">
            无优惠券可用
          </div>
        </div>
      </div>
      <div class="kqb-submit">
        <div class="kqb-submit-label">
          <span>总计：</span>
          <span class="fc-F74004">￥365.0</span>
        </div>
        <button class="kqb-btn bgC-F74044">微信支付</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'vipPrivilege',
  data () {
    return {
    }
  },
  created () {

  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    // 页面跳转
    pageJump (e) {
      console.log(e)
      const thisObj = this
      let uri = e.target.dataset.uri
      let queryData = {}
      thisObj.$router.push({
        path: uri,
        query: queryData
      })
    }
  }
}
</script>
<style scoped>
.kqb-card-list-inner {
  font-size: 40px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(255, 78, 79, 1);
}

.kqb-list-item {
  padding: 0 36px;
}

.kqb-list-item .kqb-list-label {
  font-size: 28px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}

.kqb-list-item .kqb-list-right {
  padding: 0 24px 0 0;
  font-size: 26px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(187, 187, 187, 1);
}

.kqb-submit {
  position: fixed;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 94px;
  padding: 0 17px 0 36px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 5px 23px 1px rgba(150, 174, 206, 0.63);
}

.kqb-submit .kqb-submit-label span {
  font-size: 30px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}

.kqb-submit .kqb-submit-label span.fc-F74004 {
  color: #f74004;
}

.kqb-submit .kqb-btn {
  width: 189px;
  height: 60px;
  line-height: 60px;
  padding: 0;
  border-radius: 30px;
  font-size: 30px;
  font-family: MicrosoftYaHeiLight;
  font-weight: 300;
  color: rgba(255, 255, 255, 1);
  background: #f74004;
}

.kqb-submit .kqb-btn,
.kqb-submit .kqb-btn.button-hover {
  border-color: #f74004;
}
</style>
